<template>
  <div class="gauge">
    <div class="meter" :style="'transform: rotate(' + rotation + 'turn);'">

    </div>
    <div class="percentage">
      {{percentage}}%
    </div>
  </div>
</template>
<script>
export default {
  props: [ "percentage" ],
  computed: {
    rotation(){
      return (this.percentage / 200)
    }
  }
}
</script>
<style lang="scss">
$gauge_width: 20rem;
$gauge_height: 10rem;

.gauge{
  display: inline-block;
  position: relative;
  width: $gauge_width;
  height: $gauge_height;
  overflow: hidden;
  background: #ffffff;
}
.gauge .meter{
  top: 100%;
  transition: 1.5s;
  transform-origin: center top;
  background: $sensual;
  border-radius: 0 0 ($gauge_width/2) ($gauge_width/2);
}
.gauge .percentage{
  position: absolute;
  bottom: 0;
  text-align: center;
  left: 0;
  right: 0;
  color: #000;
  z-index: 5;
}
.gauge:before, .meter {
  width:$gauge_width;
  height:$gauge_height;
}
.gauge:before, .gauge:after, .gauge .meter {
  position:absolute;
  display:block;
  content:"";
}
.gauge:before{
  border-radius: 50%;
  background: darken(#ffffff, 5);
  width: $gauge_width;
  height: $gauge_width;
}

.gauge:after{
  background: #ffffff;
  bottom: -($gauge_width/4);
  left: ($gauge_width/4);
  width: ($gauge_width/2);
  height: ($gauge_width/2);
  border-radius: 100%;
}


</style>



// WEBPACK FOOTER //
// Gauge.vue?7cb2ce10